/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.49
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ServiceName } from './ServiceName';
import {
    ServiceNameFromJSON,
    ServiceNameFromJSONTyped,
    ServiceNameToJSON,
} from './ServiceName';

/**
 * 
 * @export
 * @interface BackOfficeApiKeyRecord
 */
export interface BackOfficeApiKeyRecord {
    /**
     * 
     * @type {boolean}
     * @memberof BackOfficeApiKeyRecord
     */
    fullAccess: boolean;
    /**
     * 
     * @type {ServiceName}
     * @memberof BackOfficeApiKeyRecord
     */
    service: ServiceName;
    /**
     * Timestamp of the last time this key was used for authentication, or null if never used
     * @type {string}
     * @memberof BackOfficeApiKeyRecord
     */
    lastUsedAt?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof BackOfficeApiKeyRecord
     */
    legacy: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BackOfficeApiKeyRecord
     */
    isActive: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof BackOfficeApiKeyRecord
     */
    scopes: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof BackOfficeApiKeyRecord
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof BackOfficeApiKeyRecord
     */
    id: string;
}



/**
 * Check if a given object implements the BackOfficeApiKeyRecord interface.
 */
export function instanceOfBackOfficeApiKeyRecord(value: object): value is BackOfficeApiKeyRecord {
    if (!('fullAccess' in value) || value['fullAccess'] === undefined) return false;
    if (!('service' in value) || value['service'] === undefined) return false;
    if (!('legacy' in value) || value['legacy'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    if (!('scopes' in value) || value['scopes'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function BackOfficeApiKeyRecordFromJSON(json: any): BackOfficeApiKeyRecord {
    return BackOfficeApiKeyRecordFromJSONTyped(json, false);
}

export function BackOfficeApiKeyRecordFromJSONTyped(json: any, ignoreDiscriminator: boolean): BackOfficeApiKeyRecord {
    if (json == null) {
        return json;
    }
    return {
        
        'fullAccess': json['fullAccess'],
        'service': ServiceNameFromJSON(json['service']),
        'lastUsedAt': json['lastUsedAt'] == null ? undefined : json['lastUsedAt'],
        'legacy': json['legacy'],
        'isActive': json['isActive'],
        'scopes': json['scopes'],
        'description': json['description'],
        'id': json['id'],
    };
}

export function BackOfficeApiKeyRecordToJSON(value?: BackOfficeApiKeyRecord | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'fullAccess': value['fullAccess'],
        'service': ServiceNameToJSON(value['service']),
        'lastUsedAt': value['lastUsedAt'],
        'legacy': value['legacy'],
        'isActive': value['isActive'],
        'scopes': value['scopes'],
        'description': value['description'],
        'id': value['id'],
    };
}

